import React from "react";
import { slide as Menu } from "react-burger-menu";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../store/authSlice";
import { useNavigate, Link } from "react-router-dom";
import "./Menu.css";

const NavMenu = () => {
  const { isAuthenticated, user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate("/login", { replace: true });
  };

  return (
    <Menu /* left side by default */ styles={menuStyles} disableAutoFocus>
      <div className="menu-header">
        <h3>🐾 Knight’s Kennel</h3>
        {isAuthenticated && (
          <p className="menu-user">
            Hello, <strong>{user?.username || user?.email}</strong>
          </p>
        )}
      </div>

      <Link className="menu-item" to="/">🏠 Home</Link>
      <Link className="menu-item" to="/about">ℹ️ About</Link>
      <Link className="menu-item" to="/email">📧 Contact</Link>

      {!isAuthenticated ? (
        <>
          <Link className="menu-item" to="/register">📝 Register</Link>
          <Link className="menu-item" to="/login">🔑 Login</Link>
        </>
      ) : (
        <>
          <Link className="menu-item" to="/managepets">🐶 Manage Pets</Link>
          <Link className="menu-item" to="/dashboard">📊 Dashboard</Link>
          <Link className="menu-item" to="/upload">📷 Upload Images</Link>
          <Link className="menu-item" to="/uploadvideo">🎥 Upload Videos</Link>
          <Link className="menu-item" to="/uploaditemforsale">💰 Upload Items</Link>
          <Link className="menu-item" to="/collages">🖼️ View Collages</Link>
          <Link className="menu-item" to="/puppycam">🐶 Puppy Cam</Link>
          <Link className="menu-item" to="/viewvideos">🎬 Puppy Videos</Link>
          <Link className="menu-item" to="/viewitemsforsale">🐕‍🦺 Puppies for Sale</Link>

          <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
        </>
      )}

      <div className="menu-footer">
        <p>© {new Date().getFullYear()} Knight’s Kennel</p>
      </div>
    </Menu>
  );
};

const menuStyles = {
  bmBurgerButton: { position: "fixed", width: "28px", height: "22px", left: "25px", top: "25px" },
  bmBurgerBars: { background: "#4FC3F7", borderRadius: "2px" },
  bmCrossButton: { height: "24px", width: "24px" },
  bmCross: { background: "#fff" },
  bmMenuWrap: { position: "fixed", height: "100%" },
  bmMenu: { background: "rgba(20, 30, 40, 0.65)", backdropFilter: "blur(14px)", boxShadow: "0 0 25px rgba(0,0,0,0.6)", padding: "2.5em 1.5em 0", fontSize: "1.1em" },
  bmOverlay: { background: "rgba(0,0,0,0.4)", backdropFilter: "blur(4px)" },
};

export default NavMenu;
